<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="DED">To my parents and (how not?) my aunt and in memory of my uncle</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?c67762f0